"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alert = alert;
exports.clear = clear;
exports.warning = exports.success = exports.info = exports.error = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _config = require("../config");
var _FloatAlert = _interopRequireDefault(require("../FloatAlert"));
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var alertIns;
function clear() {
  alertIns && alertIns.close();
}
function alert(props, el) {
  var _onClose$props = _objectSpread({
      onClose: _noop["default"]
    }, props),
    children = _onClose$props.children,
    rest = (0, _objectWithoutProperties2["default"])(_onClose$props, _excluded);
  var originalOnClose = (0, _prop["default"])('onClose')(rest);
  var target = el || document.createElement('div');
  clear();
  if (!el) {
    var _getRootElement;
    (_getRootElement = (0, _config.getRootElement)()) === null || _getRootElement === void 0 ? void 0 : _getRootElement.appendChild(target);
  }
  function close() {
    // Refer to https://facebook.github.io/react/docs/react-dom.html#unmountcomponentatnode
    var unmountResult = _reactDom["default"].unmountComponentAtNode(target);
    !el && unmountResult && target.parentNode && target.parentNode.removeChild(target);
    originalOnClose.apply(void 0, arguments);
  }
  alertIns = {
    close: close
  };
  _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_FloatAlert["default"], (0, _extends2["default"])({
    className: "mg-t-9",
    onClose: close
  }, rest), children), target);
  return {
    close: close
  };
}
var wrapProps = function wrapProps(props) {
  return (0, _typeof2["default"])(props) !== 'object' ? {
    children: props
  } : _objectSpread(_objectSpread({}, props), {}, {
    children: (0, _prop["default"])('message')(props)
  });
};
var withAlert = function withAlert(type) {
  return function (props, target) {
    return alert(_objectSpread({
      type: type
    }, wrapProps(props)), target);
  };
};

/**
* @deprecated
* UI should be handled in UI layer, keep "Data-Driven" in mind.
* Imperative update UI outside UI layer would cause problems.
* */
var success = exports.success = withAlert('success');

/**
* @deprecated
* UI should be handled in UI layer, keep "Data-Driven" in mind.
* Imperative update UI outside UI layer would cause problems.
* */
var warning = exports.warning = withAlert('warning');

/**
* @deprecated
* UI should be handled in UI layer, keep "Data-Driven" in mind.
* Imperative update UI outside UI layer would cause problems.
* */
var error = exports.error = withAlert('danger');

/**
* @deprecated
* UI should be handled in UI layer, keep "Data-Driven" in mind.
* Imperative update UI outside UI layer would cause problems.
* */
var info = exports.info = withAlert('info');